import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import config from "@/config";
import { useAsyncEffect } from "@/utils/use-async-effect";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useState } from "react";

export function useShopFlagWithLoading(flag: string) {
  const [value, setValue] = useState(false);
  const [loading, setLoading] = useState(true);
  const { data: shop } = useCurrentShopSuspense();
  const ldClient = useLDClient();

  useAsyncEffect(async () => {
    await ldClient?.identify({
      key: shop.id,
      anonymous: false,
      custom: {
        shopId: shop.id,
      },
    });
    const value = (ldClient?.variation(flag, false) ?? false) as boolean;
    setValue(value);
    setLoading(false);
  }, [shop, flag]);

  return { value: config.isDev || value, loading: !config.isDev && loading };
}

export function useShopFlag(flag: string) {
  const { value } = useShopFlagWithLoading(flag);
  return value;
}
